function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SiteControls = /*#__PURE__*/function () {
  function SiteControls() {
    _classCallCheck(this, SiteControls);

    this.controlBox = document.getElementById('siteControls');
    this.adjustmentsBox = document.getElementById('screenAdjustments');
    this.contrastButtons = Array.from(this.adjustmentsBox.querySelectorAll('.contraster__btn'));
    this.defaults = {
      scale: "18px",
      contrast: "default"
    };
    this.init();
    this.bindEventHandlers();
  }

  _createClass(SiteControls, [{
    key: "init",
    value: function init() {
      if (!localStorage.getItem('kdbp-scale')) {
        localStorage.setItem('kdbp-scale', this.defaults.scale);
      }

      if (!localStorage.getItem('kdbp-contrast')) {
        localStorage.setItem('kdbp-contrast', this.defaults.contrast);
      }

      document.documentElement.dataset.scale = localStorage.getItem('kdbp-scale');
      document.documentElement.dataset.contrast = localStorage.getItem('kdbp-contrast');
      this.contrastButtons.find(function (x) {
        return x.dataset.contrast == document.documentElement.dataset.contrast;
      }).classList.add('contraster__btn--active');
    }
  }, {
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      var _this = this;

      this.controlBox.querySelector('#scrollTop').addEventListener('click', this.scrollToTop);
      this.controlBox.querySelector('#adjustToggle').addEventListener('click', function (evt) {
        return _this.toggleAdjustBox(evt, true);
      });
      this.adjustmentsBox.querySelector('#closeAdjustments').addEventListener('click', function (evt) {
        return _this.toggleAdjustBox(evt, false);
      });
      this.adjustmentsBox.querySelector('#decreaseSize').addEventListener('click', function (evt) {
        return _this.adjustTextSize(evt, false);
      });
      this.adjustmentsBox.querySelector('#increaseSize').addEventListener('click', function (evt) {
        return _this.adjustTextSize(evt, true);
      });
      this.contrastButtons.forEach(function (x) {
        return x.addEventListener('click', function (evt) {
          return _this.setContrast(evt, evt.target.dataset.contrast);
        });
      });
      this.adjustmentsBox.querySelector('#resetControls').addEventListener('click', this.resetControls.bind(this));
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop(evt) {
      evt.preventDefault();
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, {
    key: "toggleAdjustBox",
    value: function toggleAdjustBox(evt, isOpen) {
      evt.preventDefault();
      document.documentElement.classList.toggle('adjustments-open', isOpen);
    } // TODO set max

  }, {
    key: "adjustTextSize",
    value: function adjustTextSize(evt) {
      var increase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      evt.preventDefault();
      var mod = increase ? 2 : -2;
      var val = Math.round(parseInt(document.documentElement.dataset.scale) + mod);
      document.documentElement.dataset.scale = val + 'px';
      document.documentElement.style.fontSize = val + 'px';
      localStorage.setItem('kdbp-size', val + 'px');
    }
  }, {
    key: "setContrast",
    value: function setContrast(evt, value) {
      evt.preventDefault();
      var activeCls = 'contraster__btn--active';
      this.contrastButtons.forEach(function (x) {
        return x.classList.toggle(activeCls, x.dataset.contrast === value);
      });
      document.documentElement.dataset.contrast = value;
      localStorage.setItem('kdbp-contrast', value);
    }
  }, {
    key: "resetControls",
    value: function resetControls(evt) {
      evt.preventDefault();
      this.setContrast(evt, 'default');
    }
  }]);

  return SiteControls;
}();

export { SiteControls as default };